import React, { useCallback } from 'react';

import { Checkbox } from '@vtblife/uikit';
import { MiscSpecialEvent } from '@search/filter-enums/enums/SpecialEvents';

import { MiscSpecialEventsFilter } from '../../../../models/Filter';
import { Filter2 } from '../../../new_filter/Filter2';
import { CheckboxGroup2 } from '../../../common/CheckboxGroup2';

interface IDesktopMiscSpecialEventsFilterViewProps {
    filter: MiscSpecialEventsFilter;
    handleChange: (value: MiscSpecialEventsFilter) => void;
}

const ITEMS = [
    [ MiscSpecialEvent.PROMO, 'Акция' ],
    [ MiscSpecialEvent.GIFT, 'Подарок' ]
];

export const DesktopMiscSpecialEventsFilterView: React.FC<IDesktopMiscSpecialEventsFilterViewProps> = ({
    filter,
    handleChange
}) => {
    const onChange = useCallback(value => {
        handleChange(new MiscSpecialEventsFilter(value));
    }, [ handleChange ]);

    return (
        <Filter2 filterTitle='Другое'>
            <CheckboxGroup2
                mode='check'
                name='miscSpecialEvents'
                onChange={onChange}
                value={filter.value}
                isFilter
            >
                {
                    ITEMS.map(([ value, label ]) => (
                        <Checkbox
                            variant='filter'
                            key={value}
                            name={value}
                            block
                        >
                            {label}
                        </Checkbox>
                    ))
                }
            </CheckboxGroup2>
        </Filter2>
    );
};
